module.exports = __webpack_public_path__ + "static/media/index_01.c6bf2bf6.png";